<template>
  <footer class="bg-black py-20 xl:py-24">
    <div class="mx-auto grid max-w-wrapper justify-between gap-8 px-4 xl:flex xl:gap-0">
      <div class="flex flex-col gap-6 xl:gap-8">
        <FooterLogo />
        <FooterNav />
        <div class="flex flex-col gap-2 text-sm xl:gap-4">
          <FooterInfo />
          <FooterCopy />
        </div>
      </div>
      <div>
        <BaseSelect :options="[]" width="200px" placeholder="Family Site" />
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup></script>
